import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Box } from 'reflexbox';

import { ArrowLeftIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { Button, Container, PAGE_CONTENT_WIDTH, Title, Toolbar, tokens } from '@treams/treams-ui';

import { ModalContext } from '../../navigation/ModalNavigation';
import RemainingGoalsStatus from '../RemainingGoalsStatus';
import GoalTemplateSelector from './GoalTemplateSelector';

export default function GoalTemplates(props: {
	userID: string;
	returnURL: string;
	onScratch: () => void;
}) {
	const history = useHistory();
	const momentID = new URLSearchParams(history.location.search).get('moment_id') ?? undefined;

	const { t } = useTranslation();

	const [template, setTemplate] = useState<graphql.GoalTemplate | null | undefined>(undefined);

	return (
		<Container py={4} wide={PAGE_CONTENT_WIDTH}>
			{momentID && <RemainingGoalsStatus momentID={momentID} />}
			<ModalContext.Consumer>
				{(value) =>
					!value.isModal && (
						<Button
							icon={<ArrowLeftIcon />}
							link={props.returnURL}
							title={t('goals.show.toolbar.back')}
							type="plain"
							ml="-16px"
							mb={`${tokens.gap.list}px`}
						/>
					)
				}
			</ModalContext.Consumer>
			<Title mb={`${tokens.gap.section}px`}>{t('goals.edit.toolbar.templates.title')}</Title>
			<Box mb={`${tokens.gap.section}px`}>
				<GoalTemplateSelector
					userID={props.userID}
					template={template}
					onChange={setTemplate}
					onLoad={(templates) => {
						if (templates.length === 0) {
							props.onScratch();
						}
					}}
				/>
			</Box>
			<Toolbar>
				<Toolbar.Spacing />
				<Button link={props.returnURL} title={t('goals.edit.toolbar.cancel')} type="secondary" />
				<Button
					disabled={template === undefined}
					onClick={() => {
						if (!template) {
							props.onScratch();
						} else {
							const params = new URLSearchParams(history.location.search);
							params.set('template_id', template.id);
							history.push(history.location.pathname + '?' + params.toString());
						}
					}}
					title={t('goals.edit.toolbar.next')}
					type="primary"
				/>
			</Toolbar>
		</Container>
	);
}
